import React from 'react'
import { Button, type SxProps, type Theme } from '@mui/material'
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined'
import { printWebappFrame } from '../../utils/printWebappFrame'

/**
 * Download PDF for a web app (#1578 item 16): the browser's print dialog on
 * the app's frame, where "Save as PDF" makes the file.
 */
const DownloadPdfButton: React.FC<{
  frameRef: React.RefObject<HTMLIFrameElement | null>
  variant?: 'text' | 'outlined' | 'contained'
  sx?: SxProps<Theme>
}> = ({ frameRef, variant = 'outlined', sx }) => (
  <Button
    size="small"
    variant={variant}
    color="info"
    startIcon={<PictureAsPdfOutlinedIcon fontSize="small" />}
    onClick={() => printWebappFrame(frameRef.current)}
    data-testid="webapp-download-pdf"
    sx={[{ textTransform: 'none' }, ...(Array.isArray(sx) ? sx : [sx])]}
  >
    Download PDF
  </Button>
)

export default DownloadPdfButton
